import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const verifiedFlag = params.get('verified'); // set by the verify-email redirect

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !password) { setError('Please enter your credentials.'); return; }
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Login failed.');
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ position: 'fixed', top: -200, right: -200, width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(20, 80, 74,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />
      <div style={{ position: 'fixed', bottom: -150, left: -150, width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(224, 165, 38,0.05) 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div style={{ width: '100%', maxWidth: 420, position: 'relative' }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <img src="/feebe-mark-pin.png" alt="feebe" width="60" height="60" style={{ display: 'block', margin: '0 auto 16px', objectFit: 'contain' }} />
          <h1 style={{ fontSize: 30, fontWeight: 700, color: 'var(--teal)', marginBottom: 6, letterSpacing: '-0.03em' }}>
            fee<span style={{ color: 'var(--gold)' }}>be</span>
          </h1>
          <p style={{ fontSize: 12, fontWeight: 600, color: 'var(--teal)', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6 }}>Deals, delivered</p>
          <p style={{ fontSize: 13, color: 'var(--gray-500)' }}>feebe works the market — you work the offer.</p>
        </div>

        <div style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 16, padding: '36px 32px', boxShadow: '0 4px 20px rgba(26, 23, 20, 0.06)' }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: 'var(--white)', marginBottom: 6 }}>Sign in to your account</h2>
          <p style={{ fontSize: 13, color: 'var(--gray-500)', marginBottom: 28 }}>Access your deal pipeline and AI tools</p>

          {verifiedFlag === '1' && (
            <div style={{ background: 'rgba(74, 124, 89,0.12)', border: '1px solid rgba(74, 124, 89,0.3)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--green)', marginBottom: 20 }}>
              Email verified — you can sign in now.
            </div>
          )}
          {verifiedFlag === '0' && (
            <div style={{ background: 'rgba(184, 84, 80,0.12)', border: '1px solid rgba(184, 84, 80,0.3)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--red)', marginBottom: 20 }}>
              That verification link is invalid or expired. Sign in and we can resend it.
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Email address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" style={inputStyle}
                onFocus={e => Object.assign(e.target.style, inputFocusStyle)} onBlur={e => Object.assign(e.target.style, inputStyle)} />
            </div>
            <div style={{ marginBottom: 10 }}>
              <label style={labelStyle}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" style={inputStyle}
                onFocus={e => Object.assign(e.target.style, inputFocusStyle)} onBlur={e => Object.assign(e.target.style, inputStyle)} />
            </div>

            <div style={{ textAlign: 'right', marginBottom: 18 }}>
              <Link to="/forgot-password" style={linkStyle}>Forgot password?</Link>
            </div>

            {error && (
              <div style={{ background: 'rgba(184, 84, 80,0.12)', border: '1px solid rgba(184, 84, 80,0.3)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--red)', marginBottom: 20 }}>
                {error}
              </div>
            )}

            <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px 20px', background: loading ? 'rgba(20, 80, 74,0.5)' : 'var(--teal)', border: 'none', borderRadius: 10, color: '#FAF7F2', fontSize: 15, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', transition: 'all 0.2s', boxShadow: loading ? 'none' : '0 2px 8px rgba(20, 80, 74,0.18)' }}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div style={{ marginTop: 24, paddingTop: 20, borderTop: '1px solid var(--navy-border)', textAlign: 'center', fontSize: 13, color: 'var(--gray-500)' }}>
            New to feebe? <Link to="/signup" style={{ ...linkStyle, fontWeight: 600 }}>Create an account</Link>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 12, color: 'var(--gray-500)' }}>
          Powered by Claude AI · Austin, TX Market Data
        </div>
      </div>
    </div>
  );
}

const labelStyle = { display: 'block', fontSize: 13, fontWeight: 500, color: 'var(--gray-300)', marginBottom: 8 };
const linkStyle = { color: 'var(--teal)', fontSize: 13, textDecoration: 'none' };
const inputStyle = { width: '100%', padding: '11px 14px', background: 'var(--navy)', border: '1px solid var(--navy-border)', borderRadius: 8, color: 'var(--white)', fontSize: 14, outline: 'none', transition: 'border-color 0.15s', boxSizing: 'border-box' };
const inputFocusStyle = { ...inputStyle, borderColor: 'var(--teal)' };
